<template>
  <div id="" class="card-detail-payment" :class="clazz">
    <h2>
      {{ title }}
    </h2>
    <slot></slot>
    <div class="dasher-divider"></div>
    <div class="total row" v-if="dynamicAmount && payBtn">
      <BasicInput
          required
          ref="inputMoney"
          labelFor="dynamicAmount"
          inputId="dynamicAmount"
          validationsNamespace="cardDetailPayment.validations"
          :value="formattedValue"
          clazz="col-12"
          @keydown="limitInput"
          @input="checkMoneyFormat"
          @blur="changeInput(false)"
          @focus="changeInput(true)"
          @enterKey="moneyEnter"
          :label="$t('cardDetailPayment.dynamicAmount.title')"
          :inputPlaceholder="$t('cardDetailPayment.dynamicAmount.placeholder', {
            min: paymentMinAmount,
            max: paymentMaxAmount
          })"
          :validations="$v.customAmount"
      ></BasicInput>
    </div>
    <div class="total" v-if="dynamicAmount && customAmount && payBtn">
      <div>{{ $t('cardDetailPayment.total') }}</div>
      <strong class="" :class="[points ? 'c-text_content': 'c-primary']"> {{ customAmountFormat }} MXN </strong>
    </div>
    <div class="total" v-if="dynamicAmount && !payBtn">
      <strong class="center-item">{{ $t('cardDetailPayment.dynamicAmount.readonly') }}</strong>
    </div>
    <div class="total" v-if="!dynamicAmount">
      <div>{{ $t('cardDetailPayment.total') }}</div>
      <strong class="" :class="[points ? 'c-text_content': 'c-primary']"> {{ numberToMoneyString(total) }} MXN </strong>
    </div>
    <div class="dasher-divider"></div>
    <div v-if="points" class="points">
      <div>
        <BasicCheckbox :index="0" :currentValue="false">
          <div>
            {{ $t('cardDetailPayment.pointsPagando') }}
            <br/>
            <div class="poppins-font-medium f-10 f-700">
              {{ $t('cardDetailPayment.points') }} {{ points }} / {{ $t('cardDetailPayment.valuePoint') }} =
              ${{ valuePoints }}
            </div>
          </div>
        </BasicCheckbox>
      </div>
      <strong> -{{ discount }} </strong>
    </div>
    <div v-if="points" class="dasher-divider"></div>
    <div v-if="points" class="total">
      <div>{{ $t('cardDetailPayment.totalToPay') }}</div>
      <strong> {{ totalWithDiscount }} MXN </strong>
    </div>
    <div v-if="points" class="dasher-divider"></div>
    <div v-if="payBtn">
      <BasicCheckbox :index="0" :currentValue="acceptTerms" @change="checkButton" clazz="m-b-20">
        <div class="f-12 c-text_info f-500">
          {{ $t('cardDetailPayment.termsConditions1') }}
          <router-link
              to="#"
              tabindex=""
              class="c-info text-underline hover f-700"
          >{{ $t('cardDetailPayment.termsConditions2') }}
          </router-link
          >
          {{ $t('cardDetailPayment.termsConditions3') }}
          <router-link
              to="#"
              tabindex=""
              class="c-info text-underline hover f-700"
          >{{ $t('cardDetailPayment.termsConditions4') }}
          </router-link
          >
          {{ $t('cardDetailPayment.termsConditions5') }}
        </div>
      </BasicCheckbox>
      <button class="button button-filled button-primary w-100 disabled"
              v-if="disabledButton"
              :disabled="disabledButton">
        {{ $t('cardDetailPayment.doPayment') }}
      </button>
      <button class="button button-filled button-primary w-100"
              v-else
              :class="disabledButton ? 'disabled' : ''" :disabled="disabledButton" @click="doPayment()">
        {{ $t('cardDetailPayment.doPayment') }}
      </button>
    </div>
    <div class="bottom-note">
      <i aria-hidden="true" class="iconsax-money-security-card"></i>
      {{ $t('cardDetailPayment.infoPayment') }}
    </div>
  </div>
</template>

<script>
import BasicCheckbox from "@/components/BasicCheckbox.vue";
import BasicInput from '@/components/BasicInput.vue';
import {helpers, between} from 'vuelidate/lib/validators';
import {numberToMoneyString} from "@/api/utils";

const requiredIfDynamicAmount = function (value) {
  if (value === null || value === undefined) {
      return true
  }
  return this.dynamicAmount ? (helpers.req(value) && value > 0) : true;
};

const regexCleanData = new RegExp(/[0-9.]/);

const formatter = new Intl.NumberFormat("es-MX", {
  style: "currency",
  currency: "MXN",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export default {
  name: "CardDetailPayment",
  components: {
    BasicCheckbox,
    BasicInput,
  },
  props: {
    title: String,
    total: String,
    discount: String,
    totalWithDiscount: String,
    points: String,
    valuePoints: String,
    clazz: String,
    payBtn: {type: Boolean, default: true},
    disabledPayment: {type: Boolean, default: true},
    dynamicAmount: {type: Boolean, default: false},
    paymentMinAmount: {type: Number, default: 0},
    paymentMaxAmount: {type: Number, default: 0},
  },
  data() {
    return {
      acceptTerms: false,
      customAmount: null,
      activeInput: false
    }
  },
  computed: {
    disabledButton() {
      let disableByAmount = false;
      if (this.dynamicAmount) {
        disableByAmount = !this.$v.customAmount.$dirty || this.$v.customAmount.$invalid;
      }
      return this.disabledPayment || !this.acceptTerms || disableByAmount;
    },
    formattedValue: {
      get() {
        if (this.activeInput) {
          return this.customAmount;
        }
        return formatter.format(this.customAmount || 0)
      },
      set(newValue) {
        const parsedValue = Number.parseFloat(newValue.replace(/[^0-9.-]/g, ''));
        this.customAmount = Number.isNaN(parsedValue) ? 0 : parsedValue;
      },
    },
    customAmountFormat() {
      return formatter.format(this.customAmount || 0);
    }
  },
  methods: {
    doPayment() {
      if (this.acceptTerms && !this.disabledPayment) {
        // se convierte a string para mantener la coherencia con el check link normal
        this.$emit('doPayment', this.customAmount?.toString());
      }
    },
    checkButton(val) {
      this.acceptTerms = val.checkValue;
      if (val.checkValue) {
        this.$emit('checkButtonPayment');
      }
    },
    limitInput(e) {
      const value = e.target.value || '0';
      const decimalIndex = value.indexOf('.');
      const wasNumber = regexCleanData.test(e.key);
      if (
          !(
              wasNumber ||
              e.key === 'Backspace' ||
              e.key === 'Enter' ||
              e.key === 'ArrowLeft' ||
              e.key === 'ArrowRight'
          ) || (
              e.key === '.' && decimalIndex > -1
          )
      ) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    changeInput(value) {
      this.activeInput = value;
      if (!value) {
        // Se redondea a 2 decimales y en caso de que sean 0s se quitan
        this.customAmount = Number(Number.parseFloat(this.customAmount).toFixed(2));
      }
    },
    moneyEnter() {
      if (this.$refs.inputMoney) {
        this.$refs.inputMoney.setBlur();
      }
    },
    checkMoneyFormat(value) {
      const isValid = this.isValidMoneyFormat(value);
      if (isValid) {
        this.formattedValue = value;
      } else {
        this.formattedValue = this.swapDot(value);
      }
    },
    isValidMoneyFormat(str) {
      const regex = /^\d+(,\d{3})*(\.\d{0,2})?$/;
      return regex.test(str);
    },
    swapDot(str) {
      const t = str.split('');
      const indexDot = t.indexOf('.');
      if (indexDot < 0) {
        return str;
      }
      t[indexDot] = t[indexDot + 1];
      t[indexDot + 1] = '.'
      return t.join('');
    },
    numberToMoneyString(amount) {
      return numberToMoneyString(amount);
    },
  },
  validations: {
    customAmount: {
      required: requiredIfDynamicAmount,
      range(value) {
        return value ? between(this.paymentMinAmount, this.paymentMaxAmount)(value) : true;
      },
    }
  }
};
</script>


